import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { LoadService } from 'src/app/core/services/load.service';
import { OfferService } from 'src/app/core/services/offer.service';
import { BancolombiaServiceService } from 'src/app/shared/bc-connect/services/bancolombia-service.service';
import { DataLayersService } from 'src/app/core/services/data-layers.service';

@Component({
  selector: 'app-connect-modal',
  templateUrl: './connect-modal.component.html',
  styleUrls: ['./connect-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ConnectModalComponent {

  constructor(
    public load: LoadService,
    private router: Router,
    private bancolombiaService: BancolombiaServiceService,
    private offerService: OfferService,
    private dataLayerService: DataLayersService
  ) {}

  close(): void {
    const offer = this.offerService.offerSelected;
    this.dataLayerService.dl_eventoGA4_cancel_application(
      offer?.card?.productName ?? localStorage.getItem('productName'),
      String(offer?.offerId ?? localStorage.getItem('offerId') ?? ''),
      offer?.company?.name ?? localStorage.getItem('companyName'),
      DataLayersService.getOfferIsFeatured(offer?.labelType ?? '0'),
      DataLayersService.getOfferLabel(offer?.labelType ?? '0', offer?.textLabel ?? ''),
      'Icono cerrar'
    );
    this.bancolombiaService.fuaPopupRef?.close();
    this.offerService.clearOfferlocalStorage();
    this.load.closeBancolombiaModal();
    this.router.navigate(['/ofertas']);
  }

}
